import styled from 'styled-components';

const FeaturesContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;

export {
  FeaturesContainer,
};
